export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_92c52939-1937-46ec-8b38-a7739c0610fd/artifacts/9tyh0wdu_luahi%20logo%20mk2%20F.png";

export const BRAND = "#02AACF";

export const NAV_LINKS = [
  { label: "HOME", to: "/#home" },
  { label: "WORK", to: "/#portfolio" },
  { label: "PORTFOLIO", to: "/work" },
  { label: "PACKAGES", to: "/#packages" },
  { label: "ABOUT", to: "/#about" },
  { label: "CONTACT", to: "/#contact" },
];

export const SHOOT_TYPES = [
  "Lifestyle", "Portrait", "Birthday", "Couples", "Graduation", "Brand",
  "Product", "Corporate", "Influencer", "Content Creation", "Event", "Creative", "Other",
];

export const CONTACT_METHODS = ["Email", "Phone", "WhatsApp"];

export const HEARD_ABOUT = ["Instagram", "TikTok", "Facebook", "Referral", "Google", "Other"];

export const BOOKING_STATUSES = [
  "NEW", "PENDING CUSTOM TIME", "TIME SUGGESTED", "PENDING", "AWAITING PAYMENT", "CONFIRMED",
  "RESCHEDULE REQUESTED", "RESCHEDULED", "COMPLETED", "DECLINED", "CANCELLED",
];

export const QUOTE_STATUSES = [
  "NEW INQUIRY", "REVIEWING", "QUOTE SENT", "CLIENT RESPONDED", "ACCEPTED", "DECLINED", "COMPLETED",
];

export const STATUS_COLORS = {
  NEW: "#02AACF",
  "PENDING CUSTOM TIME": "#fbbf24",
  "TIME SUGGESTED": "#f59e0b",
  PENDING: "#f59e0b",
  "AWAITING PAYMENT": "#a855f7",
  CONFIRMED: "#22c55e",
  "RESCHEDULE REQUESTED": "#f97316",
  RESCHEDULED: "#3b82f6",
  COMPLETED: "#64748b",
  DECLINED: "#ef4444",
  CANCELLED: "#ef4444",
};
